// clinicBrand — light, one-clinic-at-a-time branding so the patient/staff
// surfaces (Portal, Intake, QuickAdd, etc) feel like the clinic that
// onboarded, not a generic VitaMed shell.
//
// Persisted to localStorage right now — flips to a `clinic_brand` row on the
// clinic record when the onboarding backend ships. Shape stays the same.

const STORAGE_KEY = 'vmai_clinic_brand';

export function saveClinicBrand(b) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(b)); } catch (e) { /* ignore */ }
  try { window.dispatchEvent(new CustomEvent('vmai:brand', { detail: b })); } catch (e) { /* ignore */ }
}

export function getClinicBrand() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) { return null; }
}

export function clearClinicBrand() {
  try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignore */ }
  try { window.dispatchEvent(new CustomEvent('vmai:brand', { detail: null })); } catch (e) { /* ignore */ }
}
